<script setup lang="ts">
definePageMeta({ scrollToTop: false })
const mobile = useMobile()
const productSlug = useParams((i) => helpers.unArray(i.slug))
const { ui: product, loading } = useProductQuery(() => ({ slug: productSlug.value }), 'private')

watch(
  () => product.value?.groupId,
  (curr, prev) => {
    if (import.meta.browser && (!prev || prev !== curr)) window.scrollTo({ top: 0, behavior: 'instant' })
  },
  { immediate: true }
)

const loading2 = computed(() => !product.value && loading.value)
</script>

<template>
  <ProductView :product :mobile :loading="loading2" :product-slug />
</template>
